import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class Checkbox extends PureComponent {
	render() {
		const {
			id = "",
			className = "",
			reference = "",
			onChange = () => {},
			onBlur = () => {},
			onKeyDown = () => {},
			checked = false,
			disabled = false,
			dataA,
			dataALbl = "",
			dataACat = "",
			dataAAct = "",
			label = "",
			dataQa = ""
		} = this.props;
		return (
			<input
				id={id}
				className={`checkbox ${disabled ? "checkbox-disabled" : ""} ${className}`}
				type="checkbox"
				ref={reference}
				onChange={onChange}
				onBlur={onBlur}
				defaultChecked={checked}
				aria-label={label}
				aria-checked={checked}
				disabled={disabled}
				tabIndex="0"
				data-a={dataA}
				data-a-lbl={dataALbl}
				data-a-cat={dataACat}
				data-a-act={dataAAct}
				data-qa={dataQa}
				onKeyDown={onKeyDown}
			/>
		);
	}
	static propTypes = {
		id: PropTypes.string,
		className: PropTypes.string,
		reference: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
		onChange: PropTypes.func,
		checked: PropTypes.bool,
		disabled: PropTypes.bool,
		dataA: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		dataACat: PropTypes.string,
		dataAAct: PropTypes.string,
		dataALbl: PropTypes.string,
		dataQa: PropTypes.string
	};
}

export default Checkbox;
